import { createFileRoute } from "@tanstack/react-router"
import { enforceSignupStep } from "@/features/registration-workflow"
import { SignupEmailPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-email")({
	staticData: { manualPageview: true },
	beforeLoad: () => enforceSignupStep("email"),
	component: SignupEmailPage,
})
